import { apiSlice } from "../../../app/service/Service";

export const usePlayerToPlayerCardsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        playerToPlayerChkAdd: builder.mutation({
            query: (body) => ({
                url: `GinRummy/PlayerToPlayerChkAdd`,
                method: "POST",
                body,
            })
        }),
        fetchSearchingOnlinePlayer: builder.mutation({
            query: (userId) => ({
                url: `GinRummy/FetchSearchingOnlinePlayer?userId=${userId}&LastGameEnd=${new Date().toISOString()}`,
                method: "POST",
                
            })
        }),
    })
})

export const { usePlayerToPlayerChkAddMutation , useFetchSearchingOnlinePlayerMutation} = apiSlice;
